class MobileMenu {
  constructor() {
    this.menu = document.querySelector(".js-mobileMenu")
    this.openButton = document.querySelector(".js-menuTrigger")
    this.closeButton = document.querySelector(".js-menuCloseTrigger")
    this.links = document.querySelectorAll(".js-menuItem")
    this.events()
  }

  events() {
    this.openButton.addEventListener("click", () => this.openMenu())
    this.closeButton.addEventListener("click", () => this.openMenu())
    //リンクを押したときにメニューが閉じるようにする
    this.links.forEach(e => {
      e.addEventListener("click", () => this.openMenu())
    })
  }

  openMenu() {
    // this.openButton.classList.toggle("js-menuTrigger--active")
    this.menu.classList.toggle("js-mobileMenu--active")
  }
}

export default MobileMenu
